import { registerComponent } from '../utils/vueUtils';

import DataTable from './tables/DataTable.vue';
registerComponent(DataTable);
import TableWithPagination from './tables/TableWithPagination.vue';
registerComponent(TableWithPagination);

import LiveTimestamp from './controls/LiveTimestamp.vue';
registerComponent(LiveTimestamp);
import AnimatedNumber from './controls/AnimatedNumber.vue';
registerComponent(AnimatedNumber);

import Select2 from './controls/Select2.vue';
registerComponent(Select2);

import Select2Ajax from './controls/Select2Ajax.vue';
registerComponent(Select2Ajax);

import BaseModal from './modals/BaseModal.vue';
registerComponent(BaseModal);

import N2020Toolbar from './controls/N2020Toolbar.vue';
registerComponent(N2020Toolbar);

import BejegyzesInfo from './controls/BejegyzesInfo.vue';
registerComponent(BejegyzesInfo);
import BejegyzesIkonok from './controls/BejegyzesIkonok.vue';
registerComponent(BejegyzesIkonok);

import VuelidateErrorExtractor from './controls/VuelidateErrorExtractor.vue';
registerComponent(VuelidateErrorExtractor);

import BasicLoader from './controls/BasicLoader.vue';
registerComponent(BasicLoader);
import GoTopButton from './controls/GoTopButton.vue';
registerComponent(GoTopButton);

import SzuroBadgek from './controls/SzuroBadgek.vue';
registerComponent(SzuroBadgek);
import SzuroBadgekGrouped from './controls/SzuroBadgekGrouped.vue';
registerComponent(SzuroBadgekGrouped);
import BaseMap from './controls/BaseMap.vue';
registerComponent(BaseMap);

import './modals/_index';
import './layout/_index';
